import React, { useState, useEffect } from 'react';

/**
 * Иконка сервера по URL API (требует Authorization).
 * Используется в настройках и везде, где есть server.icon_url.
 */
export function AuthServerIcon({ iconUrl, token, className, size = 20, alt = '', fallback = null }) {
  const [src, setSrc] = useState(null);
  useEffect(() => {
    if (!iconUrl) {
      setSrc(null);
      return undefined;
    }

    // Проверяем, является ли URL публичным (не требует авторизации)
    const isPublic = iconUrl.includes('/public/');

    let objectUrl;
    let cancelled = false;
    const fetchOptions = isPublic
      ? {} // Публичный URL - без токена
      : token
        ? { headers: { Authorization: `Bearer ${token}` } } // Защищенный URL - с токеном
        : null; // Защищенный URL без токена - не загружаем

    if (!fetchOptions && !isPublic) return undefined;

    setSrc(null);
    fetch(iconUrl, fetchOptions)
      .then((r) => (r.ok ? r.blob() : null))
      .then((blob) => {
        if (cancelled || !blob) return;
        objectUrl = URL.createObjectURL(blob);
        setSrc(objectUrl);
      })
      .catch(() => {});
    return () => {
      cancelled = true;
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [iconUrl, token]);

  if (!src) return fallback;
  return (
    <img
      src={src}
      alt={alt}
      className={className}
      style={{ width: size, height: size, objectFit: 'contain', verticalAlign: 'middle' }}
      onError={() => setSrc(null)}
    />
  );
}

/**
 * Иконка сервера: если передан объект с icon_url — через API (AuthServerIcon),
 * иначе показываем fallback (например, букву ника).
 */
export function ServerIcon({ server, iconUrl, className, size = 20, alt = '', fallback = null }) {
  const token = typeof localStorage !== 'undefined' ? localStorage.getItem('token') : null;
  const url = iconUrl || (server && server.icon_url) || null;
  if (!url) return fallback;
  return (
    <AuthServerIcon
      iconUrl={url}
      token={token}
      className={className}
      size={size}
      alt={alt}
      fallback={fallback}
    />
  );
}
